module.exports = __webpack_public_path__ + "static/img/bg_radious.32d7229.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_radious.png
// module id = VHZi
// module chunks = 0